/*jshint esversion:6 */
import './App.css';
import Head from "./cards/Head.jsx";
import ProjectCard from './cards/ProjectCard.jsx';
import AboutMe from './cards/AboutMe.jsx';
import Credits from './cards/Credits.jsx';
import {useState} from 'react';
 /*jshint ignore:start*/
export default App;
function App() {

  const [projectVis, setProjectVis] = useState(false);
  const [aboutVis, setAboutVis] = useState(false);
  const [creditsVis, setCreditsVis] = useState(false);
 
  return (
    <div className="App" style = {{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
        <Head setProjectVis = {setProjectVis} setAboutVis = {setAboutVis} setCreditsVis = {setCreditsVis} />

        <div id = 'contentContainer' style={{display:"flex",justifyContent:"space-evenly",flexDirection:"column"}}>
          <div style={projectVis===true?{visibility:"visible",height:'auto'}:{visibility:"hidden",height:'0'}}>
            <ProjectCard
                        direction = "row"
                        source={"https://images.unsplash.com/photo-1568909039591-91857e3f46d1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"}
                        projectName="Map Marker" 
                        projectDescription="A web app, a server and a mobile app where you can track your location. The web app allows you to see the marked locations on the map, based on user input." 
                        projectSrc="https://github.com/MirrorIce/Map-Marker"
                        projectDemoSrc="#"/>
            <ProjectCard
                  direction = "row-reverse"
                  source={"https://images.unsplash.com/photo-1587145717184-e7ee5311253d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"}
                  projectName="Home Controller" 
                  projectDescription="Platform in which you could control various devices connected through a NodeMCU, with the help of MQTT protocol" 
                  projectSrc="#"
                  projectDemoSrc="#"/>
            <ProjectCard
                        direction = "row"
                        source={process.env.PUBLIC_URL+"/weather-app-picture.png"}
                        projectName="Weather App" 
                        projectDescription="A web app, a server and a mobile app where you can track your location. The web app allows you to see the marked locations on the map, based on user input." 
                        projectSrc="https://github.com/MirrorIce/weather-app-ui"
                        projectDemoSrc="#"/>
            <ProjectCard
                        direction = "row-reverse"
                        source={"https://images.unsplash.com/photo-1471970394675-613138e45da3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"}
                        projectName="Simple notepad" 
                        projectDescription="A web app, a server and a mobile app where you can track your location. The web app allows you to see the marked locations on the map, based on user input." 
                        projectSrc="https://github.com/MirrorIce/simplenotes-ui"
                        projectDemoSrc="https://simplenotes-ui.herokuapp.com/"/>
          </div>

          <span style={aboutVis===true?{visibility:"visible",height:'auto'}:{visibility:"hidden",height:'0'}}>
           <AboutMe/>
          </span>

          <span style={creditsVis===true?{visibility:"visible",height:'auto'}:{visibility:"hidden",height:'0'}}>
           <Credits/>
          </span>
          
        </div>
    </div>
    
  );/*jshint ignore:end*/
}